export default "__VITE_ASSET__caa1783b__"